import { useFormikContext } from "formik";
import React from "react";

const ButtonWrapper = ({
  className,
  children,
  disabled,
  style,
  id,
  ...otherProps
}) => {
  const { submitForm } = useFormikContext();
  const handleSubmit = () => {
    submitForm();
  };
  const configButton = {
    variant: "contained",
    color: "primary",
    // fullWidth: true,
    onClick: handleSubmit,
  };
  return (
    <button
      className={className === undefined ? "btn btn-primary" : className}
      style={style}
      {...configButton}
      disabled={disabled}
      type="submit"
      id={id}
    >
      {children}
    </button>
  );
};

export default ButtonWrapper;
